import { isInBrowser } from '../common/const';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export function useSafeAreaInsetTop() {
    const insets = useSafeAreaInsets();

    const getWebviewStatusBarHeight = () => {
        /**
         * "Mozilla/5.0 (Linux; Android 10; PCLM50 Build/QKQ1.200216.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/79.0.3999.119 KsWebView/1.6.79.156 Mobile Safari/537.36
         * Yoda/2.4.1-rc1 NetType/WIFI StatusHT/32 Kwai/9.2.40.99999 OS_PRO_BIT/64 MAX_PHY_MEM/7411 TitleHT/50 AllowKsCallApp CT/0"
         */
        const userAgent = window.navigator.userAgent;
        const statusBarHeight = (userAgent.match(/.*StatusHT\/(\d+).*/) || [userAgent, 0])[1];
        return Number(statusBarHeight);
    };

    return isInBrowser ? getWebviewStatusBarHeight() : insets.top;
}
